// components/Testimonial.jsx
import React, { useEffect, useRef, useState } from "react";
import "./styles/Testimonials.module.css";

const Testimonial = () => {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const testimonials = [
    {
      text: "Other platforms would have cut 20–30% of my earnings for tuition matching. Goat Teachers charged zero commission — I got paid directly and fairly. I recommend it to every tutor I know.",
      name: "Ishrat Amin",
      role: "Part-time tutor | Student, North South University (NSU)",
    },
    {
      text: "The idea of Goat Teachers is genius, but more people has to engage to make it useful in mass.",
      name: "Fahiya Faiza",
      role: "Student, Brac University",
    },
    {
      text: "With Goatt, I found a verified BUET student in two days — and I actually enjoy the classes.",
      name: "Rashedul Islam",
      role: "HSC Candidate",
    },
  ];

  const prev = () =>
    setCurrent((p) => (p === 0 ? testimonials.length - 1 : p - 1));
  const next = () =>
    setCurrent((p) => (p === testimonials.length - 1 ? 0 : p + 1));

  // autoplay
  useEffect(() => {
    if (isPaused) return;
    const id = setInterval(next, 6000);
    return () => clearInterval(id);
  }, [isPaused, current]);

  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const onTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const onTouchEnd = () => {
    const delta = touchStartX.current - touchEndX.current;
    if (delta > 50) next();
    if (delta < -50) prev();
  };

  return (
    <section
      className="testimonial-section"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="overlay" />
      <div className="testimonial-container">
        <h2 className="testimonial-heading">
          যারা পড়ায়, আর যারা পড়ে—তাদের কথা
        </h2>

        <div
          className="carousel"
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          <button
            className="nav-btn left"
            aria-label="Previous testimonial"
            onClick={prev}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 18L9 12L15 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          <div
            className="track"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {testimonials.map((t, i) => (
              <article
                className="slide"
                key={i}
                aria-hidden={current !== i}
                tabIndex={current === i ? 0 : -1}
              >
                <div className="card">
                  <div className="card-top">
                    <img
                      className="quote"
                      src="https://goatteachers.com/assets/quote-icon.svg"
                      alt=""
                      aria-hidden="true"
                    />
                    <p className="text">“{t.text}”</p>
                  </div>
                  <div className="author">
                    <div className="meta">
                      <h3 className="name">{t.name}</h3>
                      <p className="role">{t.role}</p>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <button
            className="nav-btn right"
            aria-label="Next testimonial"
            onClick={next}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 6L15 12L9 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className="dots">
          {testimonials.map((_, i) => (
            <button
              key={i}
              className={`dot ${current === i ? "active" : ""}`}
              aria-label={`Go to slide ${i + 1}`}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
